export default __webpack_public_path__ + "offerBoxes.8baaf96699b51d9b2628977d3ebcf8e8.png";